import React from "react";
import preview from "../../../assets/portfolio/diberville/preview.png";

export default function Diberville() {
	return (
		<div
			style={{ margin: "0 2rem", marginTop: "4rem", width: "calc(50% - 4rem)" }}
			data-aos="fade-up"
			data-aos-delay="100">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				City of D'Iberville{" "}
			</h2>
			<h3>Document Portal and Website Redesign</h3>
			<p>
				Municipality application built into website for city staff and citizens.
			</p>
			<div
				style={{
					width: "100%",
					height: "500px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#B18631",
				}}>
				<img
					src={preview}
					alt="Document Portal and Website Redesign"
					style={{ height: "105%" }}
				/>
			</div>
		</div>
	);
}
